import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.openModal();
  }

  openModal() {
    this.modal = new bootstrap.Modal(this.element);
    this.modal.show();
  }
}
